import { Box, Flex, Spacer, Text } from '@chakra-ui/react';
import { useMemo } from 'react';

import { DeliveryInfoForm } from '~/components/orders/payments/DeliveryInfoForm';
import { useI18nLn } from '~/hooks/store';
import { equalDeliveryInfo } from '~/lib/utils/delivery_info';
import { DeliveryBundle } from '~/types/resources/deliveryBundle';
import { DeliveryInfo } from '~/types/resources/deliveryInfo';
import { GachaDetail } from '~/types/resources/gachaDetail';
import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot,
} from '../ui/accordion';

type Props = {
  gachaDetail: GachaDetail;
  playAmount: number;
  deliveryBundles: DeliveryBundle[];
  deliveryInfo: DeliveryInfo | null;
  shouldNotDeliver: boolean;
  canDeliveryInfoEdit: boolean;
  canDeliveryForRegisteredAddress: boolean;
};

const AccordionViewContainer: React.FC<{
  children: React.ReactElement<any>;
  coverAccordion: boolean;
  shouldNotDeliver: boolean;
}> = (props: {
  children: React.ReactElement<any>;
  coverAccordion: boolean;
  shouldNotDeliver: boolean;
}) => {
  const { t } = useI18nLn();
  if (!props.coverAccordion) {
    return <>{props.children}</>;
  }

  return (
    <AccordionRoot collapsible border="white" px="0px" variant="plain">
      <AccordionItem value="delivery-info">
        <AccordionItemTrigger>
          <Box
            as="span"
            flex="1"
            textAlign="left"
            colorPalette={props.shouldNotDeliver ? 'gray.400' : 'black'}
          >
            {t('components.view_registered_address')}
          </Box>
        </AccordionItemTrigger>
        <AccordionItemContent px="0">{props.children}</AccordionItemContent>
      </AccordionItem>
    </AccordionRoot>
  );
};

export const SelectDelivery: React.FC<Props> = (props: Props) => {
  const { t } = useI18nLn();
  if (props.gachaDetail.delivery_type == 0) return null;

  const deliveryCharge: number = useMemo(() => {
    const deliveryBundles = props.deliveryBundles ?? [];
    const deliveryBundle = deliveryBundles.find((deliveryBundle) => {
      if (!props.deliveryInfo) return false;
      return equalDeliveryInfo(
        props.deliveryInfo,
        deliveryBundle.delivery_info
      );
    });
    return (deliveryBundle?.available_bundle_amount ?? 0) >= props.playAmount
      ? 0
      : (props.gachaDetail.gacha_delivery_info?.charge ?? 0);
  }, [props.deliveryBundles, props.deliveryInfo]);

  return (
    <Flex flexDir="column" w="full" justify="left" gap={4}>
      <Flex flexDir="row" w="full" justify="left">
        <Text fontSize="16px" fontWeight="bold">
          {t('pages.buy.shippings.title')}
        </Text>
        <Spacer />
        {props.gachaDetail.gacha_delivery_info &&
          props.gachaDetail?.gacha_delivery_info?.charge != 0 &&
          deliveryCharge == 0 && (
            <Text fontSize="11px" fontWeight="bold" colorPalette="red">
              {t('pages.buy.shippings.different_address_warning')}
            </Text>
          )}
      </Flex>
      {!props.shouldNotDeliver ? (
        <Box>
          <AccordionViewContainer
            shouldNotDeliver={props.shouldNotDeliver}
            coverAccordion={props.canDeliveryInfoEdit}
          >
            <DeliveryInfoForm
              shipableCountries={props.gachaDetail.shipping_specs.map(
                (spec) => {
                  return spec.country;
                }
              )}
              onSubmit={async (deliveryInfo) => {
                console.log('deliveryInfo', deliveryInfo);
              }}
              isLoading={false}
            />
          </AccordionViewContainer>
          {!props.canDeliveryForRegisteredAddress && (
            <Text colorPalette="red" mx={2} my={2}>
              {t('pages.buy.shippings.cannot_ship_warning')}
            </Text>
          )}
        </Box>
      ) : (
        <Text>商品を配送しないを選択中</Text>
      )}
    </Flex>
  );
};
